/**
 * 마지막 작업 워크스페이스 기억 — 로그인/재방문 시 그 워크스페이스로 진입한다.
 *
 * 워크스페이스가 작업의 진입 단위(사용자는 항상 어떤 워크스페이스 "안"에
 * 있다)이므로, 목록 화면의 기본값은 "전체"가 아니라 마지막 작업 공간이다.
 *
 * 저장은 **계정 단위**(localStorage 키에 OIDC sub 포함) — 브라우저 단위
 * 공유 키는 같은 브라우저에서 계정을 바꿔 로그인할 때 직전 계정의 마지막
 * 선택이 승계·오염되는 버그(#267: admin 로그아웃 → 타 계정 로그인 시 기본
 * 워크스페이스로 진입)를 만들었다.
 */

const STORAGE_PREFIX = 'vsmr.lastWorkspace';
/** 계정 구분 없던 구버전 공유 키 — 오염원이므로 마이그레이션 없이 정리 삭제 */
const LEGACY_SHARED_KEY = 'vsmr.lastWorkspace';

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}.${userId}`;
}

// isWorkspaceId(예약어만 배제)로는 오염된 localStorage 값이 그대로 통과한다 —
// 저장/복원 모두 UUID 형식만 유효로 취급해 임의 문자열이 존재하지 않는 워크스페이스 필터로 흘러가는 것을 막는다.
// 기본 워크스페이스도 행(uuid)이라 예약어가 없다 — 옛 저장값 'default' 는 무효(호출부가 기본 행으로 정정).
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function isStorableSelection(value: string): boolean {
  return UUID_RE.test(value);
}

/**
 * 저장된 마지막 워크스페이스 선택 — 계정(userId=OIDC sub) 기준. 사용자
 * 미확정·저장값 없음·손상이면 null (호출부가 폴백 결정).
 */
let legacyCleaned = false;

export function getLastWorkspace(userId: string | null | undefined): string | null {
  if (!userId) return null;
  try {
    if (!legacyCleaned) {
      localStorage.removeItem(LEGACY_SHARED_KEY); // 구버전 공유 키 정리 (모듈당 1회)
      legacyCleaned = true;
    }
    const raw = localStorage.getItem(storageKey(userId));
    if (raw && isStorableSelection(raw)) return raw;
  } catch {
    // localStorage 접근 불가(프라이버시 모드 등) — 저장값 없음으로 취급
  }
  return null;
}

export function setLastWorkspace(userId: string | null | undefined, selection: string): void {
  if (!userId) return;
  try {
    if (isStorableSelection(selection)) {
      localStorage.setItem(storageKey(userId), selection);
    }
  } catch {
    // 저장 실패는 무해 — 다음 방문이 기본 워크스페이스(행)로 열릴 뿐
  }
}
